import { Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

function NavigationCenterContent() {
  const { t } = useTranslation();
  return <Typography variant="body1">{t('yourRecognitionReadyToSend')}</Typography>;
}

export { NavigationCenterContent };
